export default __webpack_public_path__ + "static/media/019-merge.2190995c.png";